module.exports = __webpack_public_path__ + "static/ecommerce2-c4d8eadfb44559fb3ca9004595a8a527.jpg";